import * as ss from 'superstruct';

export const AuResourceName = ss.enums([
  'examples',
  'users',
  'dashboard',
  'conversion',
  'conversion-filter',
  'conversion-output-stream',
  'conversion-output-stream-consumption-event',
  'paid-source',
  'retainer',
  'tracked-call',
  'tracked-url',
  'funnel-stage',
  'funnel-stage-assignment',
  'custom-tracking-param',
  'conversion-input-stream',
  'ad-account',
  'ad-data-stream',
  'integration-connection',
]);

export type AuResourceName = ss.Infer<typeof AuResourceName>;
